/* Toolworld – vareliste (sections/tw-collection-list.liquid, trin 12).
   Alt virker uden JS (filtre og sider er links, sortering er en formular). JS tilføjer:
   - sortering skifter med det samme
   - "Vis flere" i filtergrupper
   - knappen "Filtre" på mobil
   - tom liste: "Fjern senest valgte filter" (BESLUTNINGER, kategorisider punkt 12) */
(function () {
  var root = document.querySelector('[data-tw-coll]');
  if (!root) return;

  var STORE_KEY = 'tw_last_filter';

  function store(set, value) {
    try {
      if (set) sessionStorage.setItem(STORE_KEY, value);
      else return sessionStorage.getItem(STORE_KEY);
    } catch (e) {
      return null;
    }
  }

  // Kort/tabel (trin 13, K8). Valget huskes pr. varegruppe; standarden kommer fra tw_varegruppe.standardvisning.
  var viewKey = 'tw_view:' + root.getAttribute('data-tw-view-key');
  var viewSwitch = root.querySelector('[data-tw-viewswitch]');
  var markView = null;
  if (viewSwitch) {
    var viewBtns = viewSwitch.querySelectorAll('[data-tw-view-set]');
    markView = function () {
      var current = root.getAttribute('data-tw-view');
      viewBtns.forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-tw-view-set') === current ? 'true' : 'false');
      });
    };
    viewBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        var v = b.getAttribute('data-tw-view-set');
        root.setAttribute('data-tw-view', v);
        try {
          localStorage.setItem(viewKey, v);
        } catch (e) {}
        markView();
      });
    });
    viewSwitch.hidden = false;
    markView();
  }

  // 48/96 pr. side: bevar filtre og sortering, nulstil side
  root.querySelectorAll('[data-tw-perpage]').forEach(function (a) {
    var url = new URL(window.location.href);
    url.searchParams.delete('page');
    if (a.getAttribute('data-tw-perpage') === '96') url.searchParams.set('view', '96');
    else url.searchParams.delete('view');
    a.href = url.pathname + url.search;
  });

  // Sortering
  var sort = root.querySelector('[data-tw-sort]');
  if (sort) {
    sort.querySelector('select').addEventListener('change', function () {
      sort.submit();
    });
  }

  // Husk det senest valgte filter (til tom liste)
  root.addEventListener('click', function (e) {
    var a = e.target.closest('[data-tw-filter-add]');
    if (a) store(true, JSON.stringify([a.getAttribute('data-tw-filter-add'), a.getAttribute('data-tw-filter-value')]));
  });

  // "Vis flere" i en filtergruppe
  root.querySelectorAll('[data-tw-fv-toggle]').forEach(function (btn) {
    var moreLabel = btn.textContent;
    btn.addEventListener('click', function () {
      var items = btn.parentNode.querySelectorAll('[data-tw-fv-more]');
      var open = btn.getAttribute('aria-expanded') === 'true';
      items.forEach(function (li) {
        li.hidden = open;
      });
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      btn.textContent = open ? moreLabel : btn.getAttribute('data-label-less');
    });
  });

  // Trin 14 (K11): bundbjælke og filterpanel fra bunden på mobil.
  // Hvert filterklik genindlæser siden; panelet åbnes igen bagefter, så kunden kan vælge flere filtre.
  var PANEL_KEY = 'tw_filters_open';
  var mobile = window.matchMedia('(max-width: 798px)');
  var backdrop = root.querySelector('.tw-sheet-backdrop');
  var openers = root.querySelectorAll('[data-tw-filters-open]');
  root.classList.add('has-js');

  var setOpen = function (open, instant) {
    if (instant) root.classList.add('no-anim');
    root.classList.toggle('is-filters-open', open);
    if (backdrop) backdrop.hidden = !open;
    document.documentElement.classList.toggle('tw-scroll-lock', open && mobile.matches);
    openers.forEach(function (b) {
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    if (instant) {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          root.classList.remove('no-anim');
        });
      });
    }
  };

  openers.forEach(function (b) {
    b.setAttribute('aria-expanded', 'false');
    b.addEventListener('click', function () {
      setOpen(!root.classList.contains('is-filters-open'));
    });
  });
  root.querySelectorAll('[data-tw-filters-close]').forEach(function (b) {
    b.addEventListener('click', function () {
      setOpen(false);
      try {
        sessionStorage.removeItem(PANEL_KEY);
      } catch (e) {}
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-filters-open')) setOpen(false);
  });

  // Husk, at panelet var åbent, når kunden vælger et filter i det
  var panel = root.querySelector('[data-tw-filters-panel]');
  if (panel) {
    panel.addEventListener('click', function (e) {
      if (mobile.matches && e.target.closest('a.tw-fv, [data-tw-filter-add]')) {
        try {
          sessionStorage.setItem(PANEL_KEY, '1');
        } catch (err) {}
      }
    });
    panel.addEventListener('submit', function () {
      if (mobile.matches) {
        try {
          sessionStorage.setItem(PANEL_KEY, '1');
        } catch (err) {}
      }
    });
  }
  try {
    if (mobile.matches && sessionStorage.getItem(PANEL_KEY) === '1') {
      sessionStorage.removeItem(PANEL_KEY);
      setOpen(true, true);
    }
  } catch (e) {}

  // Bundbjælken
  var mbar = root.querySelector('[data-tw-mbar]');
  if (mbar) {
    mbar.hidden = false;
    var mSort = mbar.querySelector('[data-tw-mbar-sort]');
    var mainSort = root.querySelector('#tw-sort-by');
    if (mSort && mainSort) {
      mSort.addEventListener('change', function () {
        mainSort.value = mSort.value;
        mainSort.form.submit();
      });
    }
    var viewToggle = mbar.querySelector('[data-tw-view-toggle]');
    if (viewToggle) {
      var icon = viewToggle.querySelector('[data-tw-view-icon]');
      var label = viewToggle.querySelector('[data-tw-view-label]');
      var syncToggle = function () {
        var next = root.getAttribute('data-tw-view') === 'tabel' ? 'kort' : 'tabel';
        icon.className = 'tw-mbar__icon tw-viewswitch__icon tw-viewswitch__icon--' + next;
        label.textContent = label.getAttribute('data-label-' + next);
      };
      viewToggle.addEventListener('click', function () {
        var next = root.getAttribute('data-tw-view') === 'tabel' ? 'kort' : 'tabel';
        root.setAttribute('data-tw-view', next);
        try {
          localStorage.setItem(viewKey, next);
        } catch (e) {}
        syncToggle();
        if (typeof markView === 'function') markView();
      });
      syncToggle();
    }
  }

  // Prisfilter: grænserne vises efter momsvalget. Shopify filtrerer på priser inkl. moms,
  // så erhvervskundens værdier (ekskl. moms) ganges med 1,25, før formularen sendes.
  var RATE = 1.25;
  var html = document.documentElement;
  var isExcl = function () {
    return html.getAttribute('data-tw-vat') === 'excl';
  };
  var priceForm = root.querySelector('[data-tw-price-form]');
  if (priceForm) {
    var inputs = priceForm.querySelectorAll('[data-tw-price-input]');
    var toShown = function (incl, bound) {
      if (incl === '' || incl == null) return '';
      var n = parseFloat(incl);
      if (!isExcl()) return String(Math.round(n));
      return String(bound === 'min' ? Math.floor(n / RATE) : Math.ceil(n / RATE));
    };
    var render = function () {
      inputs.forEach(function (input) {
        var bound = input.getAttribute('data-tw-price-input');
        input.value = toShown(input.getAttribute('data-incl'), bound);
        input.placeholder = toShown(input.getAttribute('data-ph-incl'), bound);
      });
    };
    // Kunden skriver: gem værdien inkl. moms, så et skift af momsvalg ikke ændrer intervallet
    inputs.forEach(function (input) {
      input.addEventListener('input', function () {
        var v = input.value.trim().replace(',', '.');
        if (v === '' || isNaN(parseFloat(v))) {
          input.setAttribute('data-incl', '');
          return;
        }
        var n = parseFloat(v);
        var bound = input.getAttribute('data-tw-price-input');
        var incl = isExcl() ? (bound === 'min' ? Math.floor(n * RATE) : Math.ceil(n * RATE)) : n;
        input.setAttribute('data-incl', String(incl));
      });
    });
    priceForm.addEventListener('submit', function () {
      inputs.forEach(function (input) {
        var incl = input.getAttribute('data-incl');
        if (incl === '' || incl == null) {
          input.disabled = true; // tomme felter sendes ikke
        } else {
          input.value = incl;
        }
      });
    });
    render();
    new MutationObserver(render).observe(html, { attributes: true, attributeFilter: ['data-tw-vat'] });
  }

  // Tom liste: fjern det senest valgte filter. Findes det ikke i URL'en, fjernes det sidste filter i URL'en.
  var removeLast = root.querySelector('[data-tw-remove-last]');
  if (removeLast) {
    var url = new URL(window.location.href);
    var pairs = [];
    url.searchParams.forEach(function (v, k) {
      if (k.indexOf('filter.') === 0) pairs.push([k, v]);
    });
    if (pairs.length) {
      var target = pairs[pairs.length - 1];
      try {
        var last = JSON.parse(store(false) || 'null');
        if (last && pairs.some(function (p) { return p[0] === last[0] && p[1] === last[1]; })) target = last;
      } catch (e) {}
      var next = new URLSearchParams();
      var removed = false;
      url.searchParams.forEach(function (v, k) {
        if (!removed && k === target[0] && v === target[1]) {
          removed = true;
          return;
        }
        if (k !== 'page') next.append(k, v);
      });
      var qs = next.toString();
      removeLast.href = url.pathname + (qs ? '?' + qs : '');
      removeLast.textContent = removeLast.getAttribute('data-label-js');
    }
  }
  // Karrusel med underkategorier (K4, Johan 2026-10-10): pile på desktop, kun når listen løber over.
  // Uden JS: vandret scroll med scroll-snap (CSS). Pilene skjules på mobil i CSS.
  root.querySelectorAll('[data-tw-carousel]').forEach(function (car) {
    var track = car.querySelector('[data-tw-carousel-track]');
    var prev = car.querySelector('[data-tw-carousel-prev]');
    var next = car.querySelector('[data-tw-carousel-next]');
    if (!track || !prev || !next) return;
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var over = max > 2;
      prev.hidden = !over;
      next.hidden = !over;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max - 2;
      car.classList.toggle('is-overflowing', over);
    }
    function step(dir) {
      track.scrollBy({ left: dir * Math.max(track.clientWidth * 0.8, 160), behavior: 'smooth' });
    }
    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });
})();
